import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, MessageCircle } from 'lucide-react';
import { fadeUp, stagger } from '@/lib/motion';
import { AuthorityBadge } from '@/components/shared/Section';

const HeroBlock = () => (
  <div className="relative overflow-hidden bg-[#050E1F] text-white min-h-[85vh] flex items-center" data-testid="hero-section">
    {/* Video Background */}
    <video
      autoPlay
      muted
      loop
      playsInline
      preload="none"
      poster="/allcom_hero_poster.jpg"
      className="absolute inset-0 w-full h-full object-cover"
      style={{ opacity: 0.45 }}
      aria-hidden="true"
    >
      <source src="/hero-video-opt.mp4" type="video/mp4" />
    </video>
    <div className="absolute inset-0" style={{
      background: 'linear-gradient(135deg, rgba(5,14,31,0.75) 0%, rgba(10,37,64,0.55) 40%, rgba(5,14,31,0.40) 70%, rgba(5,14,31,0.70) 100%)'
    }} />
    <div className="absolute bottom-0 left-0 right-0 h-32" style={{
      background: 'linear-gradient(to top, rgba(5,14,31,1) 0%, rgba(5,14,31,0) 100%)'
    }} />
    <div className="absolute top-1/4 left-0 w-96 h-96 rounded-full" style={{
      background: 'radial-gradient(circle, rgba(14,165,233,0.12) 0%, transparent 70%)'
    }} />
    <div className="absolute inset-0 noise-texture" />

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36 w-full">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div initial="hidden" animate="visible" variants={stagger}>
          <motion.div variants={fadeUp} className="flex justify-center">
            <AuthorityBadge icon={ShieldCheck}>Soluciones inteligentes para empresas que no se detienen</AuthorityBadge>
          </motion.div>
          <motion.h1 variants={fadeUp} className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-semibold tracking-tight leading-[1.08] mb-6" style={{fontFamily:'Syne,sans-serif'}}>
            El futuro del autoservicio y el <span className="text-gradient-accent">Retail</span> está aquí.
          </motion.h1>
          <motion.p variants={fadeUp} className="text-lg sm:text-xl text-slate-300 leading-relaxed mb-8 max-w-2xl mx-auto">
            Ayudamos a organizaciones exigentes a modernizar su operación con autoservicio, integración y soporte técnico continuo. Nos comprometemos de verdad.
          </motion.p>
          <motion.div variants={fadeUp} className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/contacto" className="inline-flex items-center justify-center gap-2 px-7 py-4 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-[0_10px_24px_rgba(14,165,233,0.35)] hover:-translate-y-px transition-all" data-testid="hero-primary-cta">
              Agenda una reunión <ArrowRight className="w-4 h-4" />
            </Link>
            <a href="https://wa.me/56975294340?text=Hola,%20quiero%20conocer%20ALLCOM" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 text-sm font-semibold text-emerald-400 border border-emerald-400/30 rounded-xl hover:bg-emerald-400/10 transition-colors">
              <MessageCircle className="w-4 h-4" /> WhatsApp ahora
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>
  </div>
);

export default HeroBlock;
